module.exports = __webpack_public_path__ + "media/images/front/medicines/h1_pharmaceutical-59185df0e73250a1aa23fdb04699bab2.svg";